var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var CoreJoystickButton = /** @class */ (function (_super) {
    __extends(CoreJoystickButton, _super);
    function CoreJoystickButton(scene, x, y, size, onclick) {
        var _this = _super.call(this, scene, x, y, "joystick_base") || this;
        _this.scene.add.existing(_this);
        _this.setDisplaySize(size.base.width, size.base.height);
        _this.onclick = onclick;
        _this._scale = 0.7;
        _this.setInteractive({
            useHandCursor: true,
        });
        _this.on("pointerdown", function () {
            var _a;
            (_a = _this.onclick) === null || _a === void 0 ? void 0 : _a.call(_this);
        });
        _this.on("pointerover", function () {
            _this.setScale(_this._scale + 0.025);
        });
        _this.on("pointerout", function () {
            _this.setScale(_this._scale, _this._scale, true);
        });
        _this.button = _this.scene.add
            .image(_this.x, _this.y, "joystick_attack")
            .setDisplaySize(size.thumb.width, size.thumb.height)
            .setScrollFactor(0)
            .setDepth(999998);
        _this.setScale(_this._scale);
        _this.setOrigin(0.5);
        _this.setScrollFactor(0);
        _this.setDepth(99999);
        return _this;
    }
    CoreJoystickButton.prototype.setPosition = function (x, y, z, w) {
        var _a;
        _super.prototype.setPosition.call(this, x, y, z, w);
        (_a = this.button) === null || _a === void 0 ? void 0 : _a.setPosition(x, y, z, w);
        return this;
    };
    CoreJoystickButton.prototype.setScale = function (x, y, save) {
        if (save) {
            this._scale = Math.min(x, 0.7);
        }
        _super.prototype.setScale.call(this, x, y);
        this.button.setScale(x, y);
        return this;
    };
    CoreJoystickButton.prototype.setVisible = function (value) {
        _super.prototype.setVisible.call(this, value);
        this.button.setVisible(value);
        return this;
    };
    return CoreJoystickButton;
}(Phaser.GameObjects.Sprite));
export default CoreJoystickButton;
